import React from "react";
import { Heart, Brain, Users } from "lucide-react";
import BestServiceImg from "../../img/Chimney-repair-service.png";
import TherapyCards from "./TherapyCards";

const BestServices = () => {
    return (
        <section className="best-services-section">
            <div className="best-services-container">
                <div className="best-services-content">
                    <h2 className="best-services-title">Area of Specialty </h2>
                    <p className="best-services-description">
                        Prioritizing your mental health is a powerful step toward leading a
                        balanced and fulfilling life. At <strong>The Tiny Therapist</strong>,
                        we specialize in providing compassionate support and evidence-based
                        care for individuals experiencing a wide range of concerns,
                        including anxiety, depression, low self-esteem, stress, and anger
                        management.
                    </p>
                    <p className="best-services-description">
                        Our approach is centered on creating a safe and supportive space
                        where you can openly explore your challenges, gain deeper
                        self-awareness, and develop effective coping strategies. Whether you
                        are navigating day-to-day stressors or working through more complex
                        emotional difficulties, our goal is to empower you with the tools
                        and insights needed to build resilience, improve well-being, and
                        foster personal growth.
                    </p>
                </div>

                <div className="best-services-image">
                    <img
                        src="https://i.pinimg.com/736x/a3/27/82/a327820a3a44aac8eb3510994c3f0696.jpg"
                        alt="Mental Health Support"
                        className="best-services-image-img"
                    />
                </div>
            </div>
            <TherapyCards />
        </section>
    );
};

export default BestServices;
